// extracted by mini-css-extract-plugin
export default {"new":"styles_new__oLVXg","btn":"styles_btn__-rwKy","icon":"styles_icon__+t83z","btnTitle":"styles_btnTitle__QPgrc","options":"styles_options__saFYW","item":"styles_item__Kwun+"};